import url from 'url';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Component } from 'react';

import { BaseLoader } from '../Loader';
import isSubscriptionRenewable from '../../utils/subscription/isSubscriptionRenewable';
import subscribedThroughWeb from '../../utils/subscription/subscribedThroughWeb';
import hasActiveSubscription from '../../utils/subscription/hasActiveSubscription';
import getLoginRedirect from '../../utils/auth/getLoginRedirect';
import getCouponRedirect from '../../utils/subscription/getCouponRedirect';
import { PAYMENT_PATH, RENEW_PATH } from '../../constants/paths';
import { PAYMENT_FLOW } from '../../constants/subscription/flow';
import { selectSubscriptionProviderName } from '../../selectors/me';
import SubscribeLoader from './SubscribeLoader';

// exported for unit testing
export class SubscribeRoute extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    subscription: PropTypes.object.isRequired,
    me: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const routeTo = this.determineRoute();
    if (routeTo) {
      props.history.replace(routeTo);
    }
    this.state = { routeTo };
  }

  determineRoute() {
    const { auth, me, subscription, location } = this.props;

    const loginRedirect = getLoginRedirect(auth, location, PAYMENT_FLOW);
    if (loginRedirect) {
      return url.format(loginRedirect);
    }

    const couponRedirect = getCouponRedirect(me, location);
    if (couponRedirect) {
      return url.format(couponRedirect);
    }

    const hasActiveSub = hasActiveSubscription(me);
    const providerName = selectSubscriptionProviderName({ me });
    const isSubscribedThroughWeb = subscribedThroughWeb(providerName);

    if (!hasActiveSub && !isSubscribedThroughWeb) {
      return null;
    }

    const pathname = isSubscriptionRenewable({ me, subscription })
      ? RENEW_PATH
      : PAYMENT_PATH;

    return url.format({
      pathname,
      search: location.search,
    });
  }

  render() {
    return this.state.routeTo ? (
      <BaseLoader />
    ) : (
      <SubscribeLoader {...this.props} />
    );
  }
}

function mapStateToProps(state) {
  const { auth, me, subscription } = state;
  return { auth, me, subscription };
}

export default connect(mapStateToProps)(SubscribeRoute);
